// O provedor pode retornar uma mensagem em vez dos dados e do score.
export function erroRetornoCredito (retorno) {
  try {
    const dados = typeof retorno === 'string' ? JSON.parse(retorno) : retorno
    const resultado = dados?.ConsultaFamiliaPositivoResponse?.ConsultaFamiliaPositivoResult
    const mensagens = resultado?.ArrayOfMensagem?.mensagem
    return (Array.isArray(mensagens) ? mensagens : [mensagens])
      .filter(item => item && (item.codigo_erro || item.mensagem_erro))
      .map(item => [item.codigo_erro != null ? `Código ${item.codigo_erro}` : '', item.mensagem_erro || ''].filter(Boolean).join(' — '))
      .join('; ')
  } catch {
    return ''
  }
}

export function erroConsultaCredito (consultas) {
  if (!Array.isArray(consultas)) return ''
  const consulta = consultas.find(item => item.tipo === 'cdl' && item.retorno)
  return erroRetornoCredito(consulta?.retorno)
}
